import BuildingType from '@/roc/building/BuildingType';
import Effects from '@/roc/effects/Effects';
import ProductionOutputType from '@/roc/effects/Production/ProductionOutputType';
import PassiveProduction from '@/roc/effects/Production/PassiveProduction';
import ProductionDuration from '@/roc/effects/Production/ProductionDuration';
import ProductionOutput from '@/roc/effects/Production/ProductionOutput';

const CelticBroch = {
  id: '38',
  name: "Celtic Broch",
  width: 4,
  height: 3,
  type: BuildingType.EVENT,
  era: 'stoneAge',
  icon: 'Celtic_Broch',
  minLevel: 1,
  maxLevel: 60,
  url: 'https://riseofcultures.wiki.gg/wiki/Buildings/Celtic_Broch',
  flags: 0,
  counts: null,
  effects: Effects.create([
    new PassiveProduction(
      ProductionDuration.asDaily(),
      ProductionOutput.asPerLevel([
        0, 0, 0, 1.2, 1.2, 1.2, 1.4, 1.4, 1.4, 1.6,
        1.6, 1.6, 1.6, 1.8, 1.8, 1.8, 2, 2, 2, 2.2,
        2.2, 2.2, 2.2, 2.35, 2.35, 2.35, 2.6, 2.6, 2.6, 2.9,
        2.9, 2.9, 2.9, 2.95, 2.95, 2.95, 3.2, 3.2, 3.2, 3.6,
        5, 5, 5, 5, 5, 6, 6, 6, 6, 6,
        7, 7, 7, 7, 7, 8, 8, 8, 8, 8,
      ]).withOutput(ProductionOutputType.RESEARCH_POINTS),
    ),
    new PassiveProduction(
      ProductionDuration.asDaily(),
      ProductionOutput.asPerEraAndLevel({
        stoneAge: [
          0,30,39,39,39,59,59,59,75,75,84,89,89,89,102,106,106,106,117,117,124,128,128,128,138,141,141,141,151,151,157,160,160,160,169,172,172,172,180,184,188,192,196,200,204,208,212,216,220,224,228,232,236,240,244,248,252,256,260,264
        ],
        bronzeAge: [
          0,35,45,45,45,69,69,69,87,87,99,104,104,104,119,124,124,124,137,137,145,150,150,150,161,165,165,165,176,176,184,187,187,187,198,201,201,201,211,216,221,226,231,236,241,246,251,256,261,266,271,276,281,286,291,296,301,306,311,316
        ],
        minoanEra: [
          0,50,63,63,63,96,96,96,122,122,138,145,145,145,166,173,173,173,192,192,204,209,209,209,226,231,231,231,247,247,257,262,262,262,277,281,281,281,295,302,309,316,323,330,337,344,351,358,365,372,379,386,393,400,407,414,421,428,435,442
        ],
        classicGreece: [
          0,80,102,102,102,154,154,154,197,197,222,234,234,234,267,278,278,278,308,308,327,336,336,336,363,372,372,372,397,397,413,421,421,421,444,452,452,452,474,485,496,507,518,529,540,551,562,573,584,595,606,617,628,639,650,661,672,683,694,705
        ],
        earlyRome: [
          0,98,124,124,124,189,189,189,240,240,271,286,286,286,327,340,340,340,377,377,400,411,411,411,444,454,454,454,485,485,505,515,515,515,543,552,552,552,580,594,608,622,636,650,664,678,692,706,720,734,748,762,776,790,804,818,832,846,860,874
        ],
        romanEmpire: [
          0,115,147,147,147,223,223,223,284,284,321,338,338,338,386,401,401,401,445,445,473,486,486,486,525,537,537,537,574,574,597,608,608,608,642,653,653,653,685,701,717,733,749,765,781,797,813,829,845,861,877,893,909,925,941,957,973,989,1005,1021
        ],
        byzantineEra: [
          0,115,147,147,147,223,223,223,284,284,321,338,338,338,386,401,401,401,445,445,473,486,486,486,525,537,537,537,574,574,597,608,608,608,642,653,653,653,685,701,717,733,749,765,781,797,813,829,845,861,877,893,909,925,941,957,973,989,1005,1021
        ],
        ageOfTheFranks: [
          0,115,147,147,147,223,223,223,284,284,321,338,338,338,386,401,401,401,445,445,473,486,486,486,525,537,537,537,574,574,597,608,608,608,642,653,653,653,685,701,717,733,749,765,781,797,813,829,845,861,877,893,909,925,941,957,973,989,1005,1021
        ],
        feudalAge: [
          0,115,147,147,147,223,223,223,284,284,321,338,338,338,386,401,401,401,445,445,473,486,486,486,525,537,537,537,574,574,597,608,608,608,642,653,653,653,685,701,717,733,749,765,781,797,813,829,845,861,877,893,909,925,941,957,973,989,1005,1021
        ],
        iberianEra: [
          0,115,147,147,147,223,223,223,284,284,321,338,338,338,386,401,401,401,445,445,473,486,486,486,525,537,537,537,574,574,597,608,608,608,642,653,653,653,685,701,717,733,749,765,781,797,813,829,845,861,877,893,909,925,941,957,973,989,1005,1021
        ],
        kingdomOfSicily: [
          0,115,147,147,147,223,223,223,284,284,321,338,338,338,386,401,401,401,445,445,473,486,486,486,525,537,537,537,574,574,597,608,608,608,642,653,653,653,685,701,717,733,749,765,781,797,813,829,845,861,877,893,909,925,941,957,973,989,1005,1021
        ],
        highMiddleAges: [
          0,115,147,147,147,223,223,223,284,284,321,338,338,338,386,401,401,401,445,445,473,486,486,486,525,537,537,537,574,574,597,608,608,608,642,653,653,653,685,701,717,733,749,765,781,797,813,829,845,861,877,893,909,925,941,957,973,989,1005,1021
        ],
        earlyGothicEra: [
          0,115,147,147,147,223,223,223,284,284,321,338,338,338,386,401,401,401,445,445,473,486,486,486,525,537,537,537,574,574,597,608,608,608,642,653,653,653,685,701,717,733,749,765,781,797,813,829,845,861,877,893,909,925,941,957,973,989,1005,1021
        ],
        lateGothicEra: [
          0,115,147,147,147,223,223,223,284,284,321,338,338,338,386,401,401,401,445,445,473,486,486,486,525,537,537,537,574,574,597,608,608,608,642,653,653,653,685,701,717,733,749,765,781,797,813,829,845,861,877,893,909,925,941,957,973,989,1005,1021
        ]
      }).withOutput(ProductionOutputType.CURRENT_ERA_SECONDARY_GOODS),
    ),
    new PassiveProduction(
      ProductionDuration.asDaily(),
      ProductionOutput
        .asFlat(1)
        .withOutput(ProductionOutputType.CHEST)
        .withDescription('Produce chest which can include gold, food or barracks refill')
      ,
    ),
  ]),
};

export default CelticBroch;
